import React, { useState } from 'react'
import IntlService from 'services/intl/IntlService'
import { createChallenge } from 'utils/formChallenge'
import { Form } from 'ui/organisms'

export default function FormChallenge() {
  const [challenge] = useState(createChallenge())

  const onChangeHandler = e => {
    const { target } = e
    const { value } = target
    target.setCustomValidity(parseInt(value, 10) === challenge.result ? '' : IntlService.get('form.bad-captcha'))
  }

  return (
    <Form.Group title={`Sicherheitsabfrage: Ergebnis von „${challenge.text}“`}>
      <Form.Row>
        <Form.Col>
          <Form.Input placeholder="Ergebnis*" onChange={onChangeHandler} required />
        </Form.Col>
      </Form.Row>
    </Form.Group>
  )
}
